<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <!-- search-->
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                  clearable
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"> </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="customerCode"
                label="Customer Code"
                type="text"
                v-model="queryParams.customerCode"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="customerName"
                label="Customer Name"
                type="text"
                v-model="queryParams.customerName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="shopList"
                label="Choose Shop"
                item-text="name"
                item-value="id"
                menu-props="auto"
                v-model="queryParams.shopId"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                item-text="label"
                item-value="value"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="saleTypeList"
                label="Sale Type"
                item-text="label"
                item-value="value"
                v-model="queryParams.saleType"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.currencyId"
                color="blue-grey lighten-2"
                label="Choose Currency..."
                :items="currencyList"
                item-text="code"
                item-value="id"
                menu-props="auto"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <!--summary-->
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
          </v-card-title>
          <v-card-text class="font-weight-bold">
            <div>
              <span>Total Credit Paid Amount</span>
              <v-chip>
                <span>{{ totalCreditPaidAmount | decFormat }}</span>
              </v-chip>
              <v-btn
                color="primary"
                :loading="printAllLoading"
                @click="printAllARReport('printARReport')"
                >PRINT ALL</v-btn
              >
              <v-btn
                color="success"
                :loading="printAllLoading"
                @click="exportAllARReport()"
                >EXPORT ALL</v-btn
              >
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <!--list-->
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="accountReceivableReportList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.createdDateInMilliSeconds | format-ms-date-time }}</td>
              <td>{{ props.item.shopName }}</td>
              <td>{{ props.item.customerCode }}</td>
              <td>{{ props.item.customerName }}</td>
              <td>{{ props.item.invoiceNo }}</td>
              <td>{{ props.item.invoiceDateInMilliSeconds | format-ms-date-time }}</td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.receivedBy }}</td>
              <td>{{ props.item.saleType }}</td>
              <td>{{ props.item.netAmount | decFormat }}</td>
              <td>{{ props.item.creditPaidAmount | decFormat }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- print all-->
    <div
      id="printARReport"
      style="bsale: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">Account Receivable Report</p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          From: [{{ queryParams.fromDate | formatDate }}] To: [{{
            queryParams.toDate | formatDate
          }}]
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          Reported Date: [{{ reportedDate }}]
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: left">Shop</th>
              <th style="border: 1px solid black; text-align: left">
                Customer
              </th>
              <th style="border: 1px solid black; text-align: left">
                Invoice No
              </th>
              <th style="border: 1px solid black; text-align: left">
                Received Date
              </th>
              <th style="border: 1px solid black; text-align: left">
                Sale Type
              </th>
              <th style="border: 1px solid black; text-align: left">
                Net Amount
              </th>
              <th style="border: 1px solid black; text-align: left">
                Credit Paid Amount
              </th>
            </tr>
          </thead>
          <tbody
            style="border: 1px solid black"
            v-for="(header, index) in accountReceivableReportPageList"
            :key="index"
          >
            <tr
              v-for="(item, i) in header.accountReceivableReportList"
              :key="i"
            >
              <td
                style="border-left: 1px solid black; text-align: left"
                v-if="i == 0"
              >
                {{ item.shopName }}
              </td>
              <td
                style="border-left: 1px solid black; text-align: left"
                v-else
              ></td>
              <td
                style="border-left: 1px solid black; text-align: left"
                v-if="i == 0"
              >
                {{ item.customerName }} {{ "(" + item.customerCode + ")" }}
              </td>
              <td
                style="border-left: 1px solid black; text-align: left"
                v-else
              ></td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.invoiceNo }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.createdDateInMilliSeconds | format-ms-date }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.saleType }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.netAmount | decFormat }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.creditPaidAmount | decFormat }}
              </td>
            </tr>
            <tr>
              <td
                style="border: 1px solid black; font-weight: bold"
                colspan="6"
              >
                Sub Total
              </td>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
              >
                {{ header.totalCreditPaidAmount | decFormat }}
              </td>
            </tr>
          </tbody>
          <tr>
              <td
                style="border: 1px solid black; font-weight: bold"
                colspan="6"
              >
                Grand Total
              </td>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
              >
                {{ grandTotalAmount | decFormat }}
              </td>
            </tr>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { shopService } from "../../services/shop-service";
import { currencyService } from "../../services/currency-service";
import { accountReceivableReportService } from "../../services/account-receivable-report-service";

export default {
  name: "AccountReceivableReport",
  components: {},
  data: () => ({
    showListLoading: false,
    printAllLoading: false,
    isSearch: false,
    reportedDate: commonService.formatDate(new Date(), "DD/MM/YYYY"),
    breadcrumbs: [
      {
        text: "General",
        disabled: true,
      },
      {
        text: "Account Receivable Report",
        disabled: true,
      },
    ],
    headers: [
      {
        text: "Received Date",
        align: "left",
        value: "temp.receivedDate",
        sortable: false,
      },
      { text: "Shop", value: "temp.shopName", sortable: false },
      { text: "Customer Code", value: "temp.customerCode", sortable: false },
      { text: "Customer Name", value: "temp.customerName", sortable: false },
      { text: "Invoice No", value: "temp.invoiceNo", sortable: false },
      { text: "Invoice Date", value: "temp.invoiceDate", sortable: false },
      { text: "Status", value: "temp.status", sortable: false },
      { text: "Received By", value: "temp.receivedBy", sortable: false },
      { text: "Sale Type", value: "temp.saleType", sortable: false },
      { text: "Net Amount", value: "temp.netAmount", sortable: false },
      { text: "Credit Paid Amount", value: "temp.paidAmount", sortable: false },
    ],
    statusList: [
      { label: "---ALL---", value: "" },
      { label: "FINISH", value: "FINISH" },
      { label: "CREDIT", value: "CREDIT" },
    ],
    saleTypeList: [
      { label: "---ALL---", value: "" },
      { label: "RETAIL", value: "RETAIL" },
      { label: "WHOLE_SALE", value: "WHOLE_SALE" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      totalItems: 0,
    },
    queryParams: {
      fromDate: "",
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      customerCode: "",
      customerName: "",
      shopId: "",
      status: "",
      saleType: "",
      currencyId: "",
    },
    totalRows: 0,
    clonequeryParams: new Object(),
    currencyList: [],
    shopList: [],
    accountReceivableReportList: [],
    accountReceivableReportPageList: [],
    totalCreditPaidAmount: 0,
    grandTotalAmount: 0,
  }),
   watch: {
    pagination: {
      handler() {
        if(this.isSearch){
          this.getAccountReceivableReport();
        }
      },
      deep: true
    }
  },
  created() {
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.customerCode) {
      this.queryParams.customerCode = this.$route.query.customerCode;
    }
    if (this.$route.query.customerName) {
      this.queryParams.customerName = this.$route.query.customerName;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.saleType) {
      this.queryParams.saleType = this.$route.query.saleType;
    }
    if (this.$route.query.currencyId) {
      this.queryParams.currencyId = this.$route.query.currencyId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    if (this.isSearch) {
      this.onSearch();
    }
    this.getAllShop();
    this.getActiveCurrency();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "account-receivable-report",
        query: this.queryParams,
      });
      this.clonequeryParams = Object.assign({}, this.queryParams);
      this.getAccountReceivableReport();
      this.isSearch = true;
    },
    getAllShop() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          let findAll = { id: "", name: "---ALL---" };
          this.shopList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    getActiveCurrency() {
      return currencyService
        .getCurrencyByStatus("ACTIVE")
        .then((res) => {
          this.currencyList = res.data;
          let c = commonService.search(
            "defaultCurrency",
            true,
            this.currencyList
          );
          if (c) {
            this.queryParams.currencyId = c.id;
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    getAccountReceivableReport() {
      this.showListLoading = true;
      accountReceivableReportService
        .getAccountReceivableReport(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage
        )
        .then((res) => {
          if(res.data){
            this.accountReceivableReportList = res.data.accountReceivableReportList;
            this.totalCreditPaidAmount = res.data.totalCreditPaidAmount;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    printAllARReport(divName) {
      this.printAllLoading = true;
      accountReceivableReportService
        .printAccountReceivableReport(this.clonequeryParams)
        .then((res) => {
          if (res.data) {
            this.accountReceivableReportPageList =
              res.data.accountReceivableReportPageList;
            this.grandTotalAmount = res.data.grandTotalAmount;
          }
        })
        .then((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500;height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllLoading = false;
        });
    },
    exportAllARReport() {
      if(!this.isSearch){
        this.clonequeryParams.toDate = this.queryParams.toDate;
      }
      this.printAllLoading = true;
      accountReceivableReportService
        .exportAccountReceivableReportExcel(this.clonequeryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printAllLoading = false;
        });
    },
  },
};
</script>
